import { Skeleton } from 'primereact/skeleton';
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek } from 'date-fns';

// export const APP_BASE_URL = 'https://smuggest-minta-natively.ngrok-free.dev';
// export const APP_BASE_URL = 'https://a110fb4880ba.ngrok-free.app';

export const APP_BASE_URL = 'https://gujaratpharmacycouncil.co.in';
export const ASSET_PATH = 'https://gujaratpharmacycouncil.co.in';
export const IMAGE_BASEURL = ASSET_PATH + '/front/';

// export const IMAGE_BASEURL = ASSET_PATH + '/front/assets/img/search_image.png';

// PAGINATION
//default pagination Row data
export const defaultRowOptions = 100;

//default PerPageRow options
export const defaultPageRowOptions = [10, 25, 50, 100, 500];

//paginatior entries showing
export const showingEntries = 'Showing {first} to {last} of {totalRecords} pages';

//paginator links & dropdown
export const paginatorLinks = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown';

//Date Convert To YYYY/MM/DD
export function convertDateFrom(date: any) {
    date = new Date(date); //Date pass
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return year + '-' + (month <= 9 ? '0' + month : month) + '-' + (day <= 9 ? '0' + day : day);
}

//Application Type
export const freshApplicationName = 'Fresh Registration';
export const transferApplicationName = 'Transfer DD/DNH';
export const freshApplicationOtherStateName = 'Fresh Registration Other State';
export const RENEWAPPNAME = 'Registration Renew';
export const ELIGIBLENAME = 'Eligibility Certificate';
export const TRANSFERTOGUJNAME = 'Transfer In';
export const DEGREEADDITIONNAME = 'Degree Addition';
export const NAMECHANGE = 'Name Change';
export const REENTRYNAME = 'Re Entry';
export const GOODSTANDINGNAME = 'Good Standing Certificate';
export const DUPLICATECERTYNAME = 'Duplicate Certificate';
export const PENALTYNAME = 'Penalty u/s 36/42 of Pharmacy Act 1948';
export const PENALTYJANVISHWAS = 'Penalty under Jan Vishwas(Amendment of Provisions) Act, 2023';
export const ADDRESSCHANGENAME = 'Address Change';
export const ELECTORAL = 'Electoral';
export const ELECTION = 'Election Deposit';
export const Nomination = 'Nomination Form Fees';
export const DEGREENAME = 'Degree Addition';

// Application Name For Report
export const applicationNameList = [
    { name: 'Fresh Registration', code: 'fresh-registration' },
    {
        name: 'Fresh Registration Other State',
        code: 'fresh-registration-other-state'
    },
    { name: 'Transfer In', code: 'transfer-in' },
    { name: 'Eligibility Certificate', code: 'Eligibility Certificate' },
    { name: 'Registration Renew', code: 'Registration Renew' },
    { name: 'Re Entry', code: 'Re Entry' },
    { name: 'Degree Addition', code: 'Degree Addition' },
    { name: 'Name Change', code: 'Name Change' },
    { name: 'Good Standing Certificate', code: 'Good Standing Certificate' },
    {
        name: 'Penalty u/s 36/42 of Pharmacy Act 1948',
        code: 'Penalty u/s 36/42 of Pharmacy Act 1948'
    },
    {
        name: 'Penalty under Jan Vishwas(Amendment of Provisions) Act, 2023',
        code: 'Penalty under Jan Vishwas(Amendment of Provisions) Act, 2023'
    }
];

// passout status filter dropdown options
export const PassoutFilterOptions = [
    { name: 'Regular', code: 'Regular' },
    { name: 'Remedial', code: 'Remedial' }
];

// council Options
export const councilOptions = [
    { label: 'Gujarat Council of Ayurvedic And Unani Systems of Medicine', value: 'Gujarat Council of Ayurvedic And Unani Systems of Medicine' },
    { label: 'Gujarat Council of Homoepathic System Of Medicine', value: 'Gujarat Council of Homoepathic System Of Medicine' },
    { label: 'Gujarat State Dental Council', value: 'Gujarat State Dental Council' },
    { label: 'Gujarat State Allied and Healthcare Council', value: 'Gujarat State Allied and Healthcare Council' },
    { label: 'Gujarat Medical Council', value: 'Gujarat Medical Council' }
];

// verification Options
export const verificationOptions = [
    { label: '10th Board', value: '10th Board' },
    { label: '12th Board', value: '12th Board' },
    { label: 'School', value: 'School' },
    { label: 'College', value: 'College' },
    { label: 'Practical Training', value: 'Practical Training' }
];

// response Options array
export const responseOptions = ['college for passing list', 'board', 'practical training institute', 'school', 'council'];

// pci list Dropdown filter values for status column
export const statusFilterOptions = [
    { name: 'Pending', code: '0' },
    { name: 'Reupload', code: '2' }
];

// Blood Group
export const bloodGroupList = [
    { name: 'A+', code: 'A+' },
    { name: 'A-', code: 'A-' },
    { name: 'B+', code: 'B+' },
    { name: 'B-', code: 'B-' },
    { name: 'O+', code: 'O+' },
    { name: 'O-', code: 'O-' },
    { name: 'AB+', code: 'AB+' },
    { name: 'AB-', code: 'AB-' }
];

// Caste Category
export const categoryList = [
    { name: 'General', code: 'General' },
    { name: 'OBC', code: 'OBC' },
    { name: 'SC/ST', code: 'SC/ST' }
];

// Degree List
export const degreeList = [
    { name: 'B Pharm', code: 2 },
    { name: 'M Pharm', code: 3 },
    { name: 'D Pharm', code: 1 },
    { name: 'Pharm D', code: 8 },
    { name: 'Pharm D (PB)', code: 9 },
    { name: 'PhD', code: 4 },
    { name: 'Qualified', code: 7 },
    { name: 'Experience', code: 5 }
];

export const filterDegreeList = [
    { name: 'B Pharm', code: 'B Pharm' },
    { name: 'M Pharm', code: 'M Pharm' },
    { name: 'D Pharm', code: 'D Pharm' },
    { name: 'Pharm D', code: 'Pharm D' },
    { name: 'Pharm D (PB)', code: 'Pharm D (PB)' },
    { name: 'PhD', code: 'PhD' },
    { name: 'Qualified', code: 'Qualified' },
    { name: 'Experience', code: 'Experience' }
];

// Application Status Options
export const ApplicationStatusOptions = [
    // { name: 'All', code: 'All' },

    { name: 'Approved', code: 'Approved' },
    { name: 'Pending', code: 'Pending' },
    { name: 'Rejected', code: 'Rejected' },
    { name: 'Documents : Not Proper', code: 'DocUnverified' },
    { name: 'Documents : Reuploaded', code: 'DocReverified' },
    { name: 'Hold', code: 'Hold' }
];

// Status options
export const PreOtherStatusOptions = [
    { name: 'All', code: 'All' },
    { name: 'Documents : Not Proper', code: 'DocUnverified' },
    { name: 'Documents : Under review', code: 'DocInVerification' },
    { name: 'Documents : Reuploaded', code: 'DocReverified' },
    { name: 'Documents : OK', code: 'DocVerified' },
    { name: 'Appointment Booked', code: 'Appointment Booked' }
];

// Status options
export const OTHERAPPOPTION = [
    { name: 'Un Hold', code: 0 },
    { name: 'Hold', code: 3 },
    { name: 'Rejected', code: 2 }
];

// Status options
export const APPLICATIONOTHERAPPOPTION = [
    { name: 'Un Hold', code: 0 },
    { name: 'Hold', code: 3 },
    { name: 'Rejected', code: 2 },
    { name: 'Document Not Proper', code: 4 }
];

// View Application Change Status Dropdown
export const VIEW_APP_CHANGE_STATUS_DROPDOWN = [
    { name: 'Hold', code: 'Hold' },
    { name: 'Unhold', code: 'Unhold' },
    { name: 'Permanent Closed', code: 'Permanent Closed' }
];

// Status options
export const DataStatusOptions = [
    { name: 'Approved', code: '1' },
    { name: 'Pending', code: '0' },
    { name: 'Rejected', code: '2' },
    { name: 'Documents : Not Proper', code: '4' },
    { name: 'Documents : Reuploaded', code: '5' },
    { name: 'Hold', code: '3' }
];

// ElectionData Status
export const ElectionDataStatusOptions = [
    { name: 'Approved', code: '1' },
    { name: 'Pending', code: '3' },
    { name: 'Rejected', code: '2' }
];

// Pro to Org Status Option
export const ProToOrgStatusOptions = [
    { name: 'Approved', code: 'Yes' },
    { name: 'Pending', code: 'No' },
    { name: 'Rejected', code: 'Rejected' }
];

// course status options
export const CourseStatusOptions = [
    { name: 'Open', code: 'Open' },
    { name: 'Closed', code: 'Closed' },
    { name: 'Completed', code: 'Completed' }
];

// active / Inactive options
export const ActiveInactiveOptions = [
    { name: 'Active', code: '1' },
    { name: 'Inactive', code: '0' }
];

// course status options
export const ResultFilterOptions = [
    { name: 'All', code: 'All' },
    { name: 'Pass', code: 'Pass' },
    { name: 'Fail', code: 'Fail' }
];

// course status options
export const DesignationFilterOptions = [
    { label: 'Invited Speaker', value: 'Invited Speaker' },
    { label: 'Course Director', value: 'Course Director' },
    { label: 'Course  Coordinator', value: 'Coordinator' },
    { label: 'Course  Co-Coordinator', value: 'Co-Coordinator' }
];

//default slot options
export const defaultSlotOptions = [
    { name: '50 Slots', code: 50 },
    { name: '100 Slots', code: 100 },
    { name: '150 Slots', code: 150 },
    { name: '200 Slots', code: 200 },
    { name: '250 Slots', code: 250 },
    { name: '300 Slots', code: 300 },
    { name: '350 Slots', code: 350 },
    { name: '400 Slots', code: 400 },
    { name: '450 Slots', code: 450 },
    { name: '500 Slots', code: 500 },
    { name: '550 Slots', code: 550 },
    { name: '600 Slots', code: 600 },
    { name: '650 Slots', code: 650 },
    { name: '700 Slots', code: 700 },
    { name: '750 Slots', code: 750 },
    { name: '800 Slots', code: 800 },
    { name: '850 Slots', code: 850 },
    { name: '900 Slots', code: 900 },
    { name: '950 Slots', code: 950 },
    { name: '1000 Slots', code: 1000 }
];

//Book appointment application type
export const bookAppointmentApplication = [
    { name: 'Fresh Application', code: 1 },
    { name: 'Fresh Other Application', code: 25 },
    { name: 'Transfer Application', code: 5 },
    { name: 'Transfer DD/DNH', code: 30 }
];

//Book appointment application type
export const bookAppointmentGraphApplication = [
    { name: 'All', code: 'all' },
    { name: 'Fresh Application', code: 1 },
    { name: 'Fresh Other Application', code: 25 },
    { name: 'Transfer Application', code: 5 },
    { name: 'Transfer DD/DNH', code: 30 }
];

//Appointment Start Time
export const startTime = [
    { name: '10:00 AM', code: '10:00 AM' },
    { name: '10:30 AM', code: '10:30 AM' },
    { name: '11:00 AM', code: '11:00 AM' },
    { name: '11:30 AM', code: '11:30 AM' },
    { name: '12:00 PM', code: '12:00 PM' },
    { name: '12:30 PM', code: '12:30 PM' },
    { name: '1:00 PM', code: '1:00 PM' },
    { name: '1:30 PM', code: '1:30 PM' },
    { name: '2:00 PM', code: '2:00 PM' },
    { name: '2:30 PM', code: '2:30 PM' }
];

//Appointment End Time
export const endTime = [
    { name: '10:30 AM', code: '10:30 AM' },
    { name: '11:00 AM', code: '11:00 AM' },
    { name: '11:30 AM', code: '11:30 AM' },
    { name: '12:00 PM', code: '12:00 PM' },
    { name: '12:30 PM', code: '12:30 PM' },
    { name: '1:00 PM', code: '1:00 PM' },
    { name: '1:30 PM', code: '1:30 PM' },
    { name: '2:00 PM', code: '2:00 PM' },
    { name: '2:30 PM', code: '2:30 PM' },
    { name: '3:00 PM', code: '3:00 PM' }
];

// Reason Options
export const reasonOptions = [
    {
        name: 'COMPLAIN RECEIVED UNDER SECTION 36 AND/OR 42 of Pharmacy Act',
        code: 'COMPLAIN RECEIVED UNDER SECTION 36 AND/OR 42 of Pharmacy Act'
    },
    {
        name: 'DOCUMENTS NOT UPLODED, PLEASE SHARE DOCUMENT ON +91 9081808600',
        code: 'DOCUMENTS NOT UPLODED, PLEASE SHARE DOCUMENT ON +91 9081808600'
    },
    {
        name: 'REFRESHER COURSE CERTIFICATE RECEIVED AFTER 1st APRIL 2019 IS REQUIRED',
        code: 'REFRESHER COURSE CERTIFICATE RECEIVED AFTER 1st APRIL 2019 IS REQUIRED'
    },
    {
        name: 'SHARE ADDRESS PROOF OF GUJARAT FOR RENEWAL ON +91 9081808300',
        code: 'SHARE ADDRESS PROOF OF GUJARAT FOR RENEWAL ON +91 9081808300'
    },
    {
        name: 'SHARE ADDRESS PROOF OF GUJARAT FOR REENTRY ON +91 9081808600',
        code: 'SHARE ADDRESS PROOF OF GUJARAT FOR REENTRY ON +91 9081808600'
    },

    {
        name: 'UPLOAD PROPERLY SCANNED PDF COPY OF THE DOCUMENT',
        code: 'UPLOAD PROPERLY SCANNED PDF COPY OF THE DOCUMENT'
    },

    {
        name: 'PLEASE UPLOAD ADDRESS PROOF OF GUJARAT ONLY (NOT OTHER STATE)',
        code: 'PLEASE UPLOAD ADDRESS PROOF OF GUJARAT ONLY (NOT OTHER STATE)'
    },
    {
        name: 'UPLOAD PROOF OF NAME CHANGE ALONG WITH ADDRESS PROOF IN SINGLE PDF',
        code: 'UPLOAD PROOF OF NAME CHANGE ALONG WITH ADDRESS PROOF IN SINGLE PDF'
    },
    {
        name: 'UPLOAD MARRIAGE CERTIFICATE AND ADDRESS PROOF IN A SINGLE PDF',
        code: 'UPLOAD MARRIAGE CERTIFICATE AND ADDRESS PROOF IN A SINGLE PDF'
    },
    {
        name: 'MULTIPLE APPLICATION RECEIVED, PREVIOUS IS STILL PENDING',
        code: 'MULTIPLE APPLICATION RECEIVED, PREVIOUS IS STILL PENDING'
    },
    {
        name: 'MULTIPLE APPLICATION RECEIVED, ONE IS ALREADY APPROVED',
        code: 'MULTIPLE APPLICATION RECEIVED, ONE IS ALREADY APPROVED'
    },
    {
        name: 'JOB PROOF NOT UPLOADED, PLEASE SHARE JOB PROOF ON +91 9081808600',
        code: 'JOB PROOF NOT UPLOADED, PLEASE SHARE JOB PROOF ON +91 9081808600'
    },
    {
        name: 'INVALID JOB PROOF',
        code: 'INVALID JOB PROOF'
    },
    {
        name: 'DEGREE CERTIFICATE NOT UPLOADED/ INVALID DEGREE CERTIFICATE, PLEASE SHARE DOCUMENT ON +91 9081808600',
        code: 'DEGREE CERTIFICATE NOT UPLOADED/ INVALID DEGREE CERTIFICATE, PLEASE SHARE DOCUMENT ON +91 9081808600'
    },
    {
        name: 'REGISTRATION CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808600',
        code: 'REGISTRATION CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808600'
    },
    {
        name: 'DEGREE CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500',
        code: 'DEGREE CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500'
    },
    {
        name: 'PCI APPROVAL OF THE SUBJECT NOT UPLOADED SHARE COPY ON 9081808600',
        code: 'PCI APPROVAL OF THE SUBJECT NOT UPLOADED SHARE COPY ON 9081808600'
    },
    {
        name: 'ALL SEM MARKSHEETS ARE NOT UPLOADED, PLEASE SHARE US ON +91 9081808600',
        code: 'ALL SEM MARKSHEETS ARE NOT UPLOADED, PLEASE SHARE US ON +91 9081808600'
    },
    {
        name: 'SHARE PASSPORT SIZE PHOTO IN JPEG/JPG/PNG FORMAT WITH REGISTRATION NUMBER AND NAME ON +91 9081808300 ',
        code: 'SHARE PASSPORT SIZE PHOTO IN JPEG/JPG/PNG FORMAT WITH REGISTRATION NUMBER AND NAME ON +91 9081808300 '
    },
    {
        name: 'BONOFIDE, TRANSFER, MIGRATION, LEAVING CERTIFICATE NOT UPLOADED, PLEASE SHARE ON +91 9081808600',
        code: 'BONOFIDE, TRANSFER, MIGRATION, LEAVING CERTIFICATE NOT UPLOADED, PLEASE SHARE ON +91 9081808600'
    },
    {
        name: 'PLEASE SHARE BOTH SIDE OF AADHAR CARD IN SINGLE PDF ON +91 9081808600',
        code: 'PLEASE SHARE BOTH SIDE OF AADHAR CARD IN SINGLE PDF ON +91 9081808600'
    },
    {
        name: 'UPLOAD BOTH SIDE OF AADHAR CARD IN SINGLE PDF',
        code: 'UPLOAD BOTH SIDE OF AADHAR CARD IN SINGLE PDF'
    },
    {
        name: 'UPLOAD AADHAR CARD WITHOUT PASSWORD PROTECTED FILE',
        code: 'UPLOAD AADHAR CARD WITHOUT PASSWORD PROTECTED FILE'
    },
    {
        name: 'MARRIAGE CERTIFICATE/ GAZETTED COPY NOT UPLOADED, PLEASE SHARE ON +91 9081808500',
        code: 'MARRIAGE CERTIFICATE/ GAZETTED COPY NOT UPLOADED, PLEASE SHARE ON +91 9081808500'
    },
    {
        name: '12th BOARD IS NOT APPROVED BOARD',
        code: '12th BOARD IS NOT APPROVED BOARD'
    },
    {
        name: '10th BOARD IS NOT APPROVED BOARD',
        code: '10th BOARD IS NOT APPROVED BOARD'
    },

    {
        name: 'COLLEGE/ COURSE APPROVAL OF  U/S 12 BY PCI REQUIRED',
        code: 'COLLEGE/ COURSE APPROVAL OF  U/S 12 BY PCI REQUIRED'
    },
    {
        name: 'UPLOAD VALID LIFE CERTIFICATE',
        code: 'UPLOAD VALID LIFE CERTIFICATE'
    },
    {
        name: 'INVALID ADDRESS PROOF',
        code: 'INVALID ADDRESS PROOF'
    },
    {
        name: 'INVALID REFRESHER COURSE CERTIFICATE',
        code: 'INVALID REFRESHER COURSE CERTIFICATE'
    },
    {
        name: 'REGISTRATION CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500',
        code: 'REGISTRATION CERTIFICATE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500'
    },
    {
        name: 'SHARE PASSPORT SIZE PHOTO IN JPEG/JPG/PNG FORMAT ON +91 9081808500',
        code: 'SHARE PASSPORT SIZE PHOTO IN JPEG/JPG/PNG FORMAT ON +91 9081808500'
    },
    {
        name: 'PROOF OF BIRTH DATE AND BIRTH PLACE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500',
        code: 'PROOF OF BIRTH DATE AND BIRTH PLACE NOT UPLOADED, PLEASE SHARE DOCUMENT ON +91 9081808500'
    },
    {
        name: 'DOCUMENT NOT PROPER',
        code: 'DOCUMENT NOT PROPER'
    },
    {
        name: 'APPLICATION DONE IN WRONG MENU',
        code: 'APPLICATION DONE IN WRONG MENU'
    },

    {
        name: '10th MARKSHEET ONLINE NOT VERIFIED',
        code: '10th MARKSHEET ONLINE NOT VERIFIED'
    },
    {
        name: '12th MARKSHEET ONLINE NOT VERIFIED',
        code: '12th MARKSHEET ONLINE NOT VERIFIED'
    },
    {
        name: 'Exit exam result not uploaded',
        code: 'Exit exam result not uploaded'
    },
    {
        name: 'Exit exam result not valid',
        code: 'Exit exam result not valid'
    },
    {
        name: 'Already registered in GSPC',
        code: 'Already registered in GSPC'
    }
];

//Account bankTypes
export const accBankTypes = [
    { name: 'SBI - Current Account', code: 128 },
    { name: 'Kotak Bank', code: 151 },
    { name: 'HDFC Bank - Current Account', code: 209 },
    { name: 'SBI - Saving Account', code: -2 }
];

// D/W List
export const DWLIST = [
    { name: 'DEPOSIT', code: 'D' },
    { name: 'WITHDRAW', code: 'W' }
];

// P/R List
export const PRLIST = [
    { name: 'PAID', code: 'P' },
    { name: 'RECEIVED', code: 'R' }
];

//Account Group
export const ACCOUNTGROUP = [
    { name: 'Liabilities', code: 1 },
    { name: 'Assets', code: 2 },
    { name: 'Expense', code: 3 },
    { name: 'Income', code: 4 },
    { name: 'Trading Expense', code: 5 },
    { name: 'Trading Income', code: 6 }
];

//Account type
export const ACCOUNTTYPE = [
    { name: 'Credit', code: 'credit' },
    { name: 'Debit', code: 'debit' }
];

export const DataStatusOptionsDuplicates = [
    { name: 'Generated', code: '1' },
    { name: 'Pending', code: '0' }
];

// To Address For GoodStanding
export const USTOADDRESS = 'National Association of Boards of Pharmacy, Foreign Pharmacy Graduate Examination Committee, 1600-Feehanville Drive, Mt.';
export const CANADATOADDRESS = 'The Pharmacy Examination Board of Canada, 200-59 Hayden Street, Toronto ON, M4Y 0E7, Canada';
export const UKTOADDRESS = 'International Registration Department, Royal Pharmaceutical Society of Great Britain,1 Lambeth High Street,London SE 1 7JN.';

//In-Out Type
export const inOutMainType = [
    { name: 'General', code: 8 },
    { name: 'Confidential ( Any Document from college/University)', code: 118 }
];

//emilPattern
export const emailPattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);

// skeleton items & length
export const Skeletonitems: number[] = Array.from({ length: 10 }, (v, i) => i);

// SKELETON FOR COLUMN BODY
export function SkeletonbodyTemplate(): JSX.Element {
    return <Skeleton></Skeleton>;
}

export const customeDateOptions = [
    { label: 'This Week', from: startOfWeek(new Date()), to: endOfWeek(new Date()) },
    { label: 'This Month', from: startOfMonth(new Date()), to: endOfMonth(new Date()) }
];

//Month List
export const monthShortNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//Other Master Type List
export const otherMasterTypes = [
    { name: 'Customer Bank', code: 'customer_bank' },
    { name: 'Inward Type', code: 'inward' },
    { name: 'Outward Type', code: 'outward' }
];

// Scrutiny Status
export const SVERIFICATION = 'Verification';
export const SPREPARE = 'Scrutiny Prepare';
export const SCHECK = 'Scrutiny Check';
export const SHOLD = 'Scrutiny Hold';

// Tabs for Scrutiny
// Registrar Tabs

export const RegistrarTabs = [
    {
        id: 'scrutiny-verification-1',
        content: 'Scrutiny Verification',
        panelID: 'scrutiny-verification-content-1'
    },
    {
        id: 'scrutiny-prepare-1',
        content: 'Scrutiny Prepare',
        panelID: 'scrutiny-prepare-content-1'
    },
    {
        id: 'scrutiny-check-1',
        content: 'Scrutiny Check',
        panelID: 'scrutiny-check-content-1'
    },
    {
        id: 'scrutiny-hold-1',
        content: 'Scrutiny Hold',
        panelID: 'scrutiny-hold-content-1'
    }
];

// Application Type No
export const freshApplicationNo = 1;
export const freshApplicationOtherNo = 25;
export const transfertoGujApplicationNo = 27;
export const transfertoDDDNH = 30;

// Fee Register Options
export const feeRegisterType = [
    { name: 'Fee Register', code: 'fee_register' },
    { name: 'Fee Summary', code: 'fee_summary' }
];

// Fresh Registration Register options
export const freshRegisterType = [
    { name: 'Pending G No (Gujarat)', code: 'fresh-registration' },
    {
        name: 'Pending G No (Other State)',
        code: 'fresh-registration-other-state'
    },
    { name: 'Pending G No (Transfer In)', code: 'transfer-in' }
];

// Registration Prefix
export const REGPREFIX = [
    { name: 'All', code: 'All' },
    { name: 'G', code: 'G' },
    { name: 'GDD', code: 'GDD' },
    { name: 'GDNH', code: 'GDNH' },
    { name: 'M', code: 'M' }
];

// Inward Outward Options
export const inOut = [
    { name: 'Inward', code: 'inward' },
    { name: 'Outward', code: 'outward' }
];
//Inward Outward Types Options
export const inOutTypes = [
    { name: 'General', code: '8' },
    { name: 'Confidential', code: '118' },
    { name: 'Verification', code: 'verification' }
];

// Verification Choice Data
export const verificationChoiceData = [
    {
        name: 'School',
        key: 'School'
    },
    {
        name: 'Board',
        key: 'Board'
    },
    {
        name: 'College',
        key: 'College'
    },
    {
        name: 'University',
        key: 'University'
    },
    {
        name: 'Council',
        key: 'Council'
    },
    {
        name: 'Practical Training Center',
        key: 'Practical Training Center'
    },
    {
        name: 'Other',
        key: 'Other'
    }
];

export const datePickerOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: 'last7day' },
    { label: 'Last 30 Days', value: 'last30days' },
    { label: 'Last 90 Days', value: 'last90days' },
    { label: 'Last Month', value: 'lastmonth' },
    { label: 'Last Year', value: 'lastyear' },
    { label: 'Week to date', value: 'weektodate' },
    { label: 'Month to date', value: 'monthtodate' },
    { label: 'Year to date', value: 'yeartodate' }
];
